<template>
  <div id="#app">
    <!-- 一级路由出口 -->
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
import { initProject } from "@/api";
import { startIdleTimer, stopIdleTimer } from "@/utils/idleTimeout";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      initProjectList: {},
      isRouterAlive: true,
    };
  },
  created() {
    //每次初始化的时候都刷新用户数据
    this.fetchAndSetUserInfo();
  },
  mounted() {
    this.init();
    this.setupIdleTimer();
  },
  beforeDestroy() {
    stopIdleTimer();
  },
  methods: {
    ...mapActions(useMainStore, {
      changeInit: "updateInitProject",
      fetchAndSetUserInfo: "fetchAndSetUserInfo",
      logout: "logout",
    }),
    init() {
      let that = this;
      initProject().then((res) => {
        that.initProjectList = res.data.data;
        that.changeInit(that.initProjectList);
      });
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    /**
     * Start idle timeout: auto-logout after 15 minutes of inactivity
     */
    setupIdleTimer() {
      const token = localStorage.getItem("token");
      if (!token) return; // Not logged in, skip

      const FIFTEEN_MINUTES = 15 * 60 * 1000;
      startIdleTimer(() => {
        this.handleIdleTimeout();
      }, FIFTEEN_MINUTES);
    },
    handleIdleTimeout() {
      stopIdleTimer();
      this.logout();
      this.$message.warning("由于长时间未操作，系统已自动退出登录，请重新登录");
      this.$router.push("/login");
    },
  },

  components: {},
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
@import url("//at.alicdn.com/t/font_3043622_0cyhzljri0hs.css");
</style>
